import { render, staticRenderFns } from "./CustomPayment-RISKPRO.vue?vue&type=template&id=d143f016&scoped=true&"
import script from "./CustomPayment-RISKPRO.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-RISKPRO.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-RISKPRO.vue?vue&type=style&index=0&id=d143f016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d143f016",
  null
  
)

export default component.exports